import * as THREE from 'three/webgpu';
import RAPIER from '@dimforge/rapier3d-simd-compat';
import { Inputs } from './inputs.js';
import { Pane } from 'tweakpane';

const physicsDebug = {
    mesh: new THREE.LineSegments(),

    init: function() {
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.Float32BufferAttribute([], 3));
        geometry.setAttribute('color', new THREE.Float32BufferAttribute([], 4));
        this.mesh.geometry = geometry;

        const material = new THREE.LineBasicNodeMaterial({
            vertexColors: true
        })
        this.mesh.material = material;

    },
    update: function( world ) {
        const { vertices, colors } = world.debugRender()
        // console.log(vertices, colors);
        this.mesh.geometry.setAttribute('position',
            new THREE.BufferAttribute(vertices, 3)
        )
        this.mesh.geometry.setAttribute('color',
            new THREE.BufferAttribute(colors, 4)
        )
    }
}


customElements.define('game-app', class extends HTMLElement {
    constructor() {
        super();
        this.style.display = 'block';
        this.style.width = '100%';
        this.style.height = '100%';
        this.style.position = 'relative';

        this.scene = new THREE.Scene();

        this.gameObjects = new Map();

        // Issue with no bundler like Vite
        this.fullscreenImg = document.createElement('img');
        this.fullscreenImg.src = './svg/full-screen-square-svgrepo-com.svg';
        // https://www.svgrepo.com/svg/528274/full-screen-square
        this.fullscreenImg.style.position = 'absolute';
        this.fullscreenImg.style.right = '20px';
        this.fullscreenImg.style.top = '100px';
        this.fullscreenImg.style.width = '50px';
        this.fullscreenImg.style.height = '50px';
        this.fullscreenImg.style.cursor = 'pointer';
        this.fullscreenImg.addEventListener('click', () => {
            if (!document.fullscreenElement) {
                document.body.requestFullscreen();
            } else {
                document.exitFullscreen();
            }
        });

        this.appendChild(this.fullscreenImg);
    }

    connectedCallback() {
        
    }

    async init({
            debug=false,
        } = {}) {

        await RAPIER.init();
        console.log('RAPIER initialized!');

        this.world = new RAPIER.World({x: 0, y: -9.81, z: 0});
        this.physicsTicksPerSecond = 60;
        this.world.timestep = 1 / this.physicsTicksPerSecond;

        this.inputs = null;

        this.animateTimer = setInterval(
            () => this.update(),
            1000 / this.physicsTicksPerSecond
        );

        // Update the size of the viewport
        for (let id=0; id < this.children.length; id++) {
            const child = this.children[id];
            if (child.localName === 'game-viewport') {
                child.updateRendererSize();
            };
        };

        // Connect virtual inputs if exist
        for (let id=0; id < this.children.length; id++) {
            const child = this.children[id];
            if (child.localName === 'game-virtual-inputs') {
                child.inputs = this.inputs;
            };
        };

        this.debug = debug;

        if (this.debug) {

            // Add Physics Debug
            physicsDebug.init();
            this.scene.add( physicsDebug.mesh );

            // Add Debug Pane
            this.debugPane = new Pane({
                title: '🐞 Debug',
            });

            for (const child of this.children) {
                if (child.localName === 'game-viewport') {
                    const statsFolder = this.debugPane.addFolder({
                        title: '📈 Stats',
                        expanded: false,
                    });
                    const memoryFolder = statsFolder.addFolder({ title: 'Memory' });
                    memoryFolder.addBinding( child.renderer.info.memory, 'geometries', { readonly: true} );
                    memoryFolder.addBinding( child.renderer.info.memory, 'textures', { readonly: true} );
                    const renderFolder = statsFolder.addFolder({ title: 'Render' });
                    renderFolder.addBinding( child.renderer.info.render, 'drawCalls', { readonly: true} );
                    renderFolder.addBinding( child.renderer.info.render, 'frameCalls', { readonly: true} );
                    renderFolder.addBinding( child.renderer.info.render, 'triangles', { readonly: true} );
                    renderFolder.addBinding( child.renderer.info.render, 'points', { readonly: true} );
                    renderFolder.addBinding( child.renderer.info.render, 'lines', { readonly: true} );
                    const programsFolder = statsFolder.addFolder({ title: 'Compute' });
                    programsFolder.addBinding( child.renderer.info.compute, 'calls', { readonly: true, label: 'Count'} );
                }
            }
        }

        console.log('Game Engine initialized!');
    }

    update() {
        this.updatePhysics();
        // Advance the simulation by one time step.
        this.world.step();

        for( let gameObject of this.gameObjects.values() ) {
            gameObject.updatePhysics( this.world.timestep );
        }

        // Update the position and orientation of the visual objects
        // this.entities.forEach( (entity) => {
        //     if (entity.visual) {
        //         if (entity.physical.bodyType() === RAPIER.RigidBodyType.Dynamic) {
        //             
        //             entity.visual.position.copy(entity.physical.translation());
        //             entity.visual.quaternion.copy(entity.physical.rotation());
        //         }
        //         else if (entity.physical.bodyType() === RAPIER.RigidBodyType.KinematicVelocityBased) {
        //             if (entity.velocity) {
        //                 // console.log(entity.velocity);
        //                 const collider = entity.physical.collider(0);
        //                 const desiredTranslation = entity.velocity.clone().multiplyScalar(this.world.timestep);
        //                 // console.log(desiredTranslation);
        //                 this.characterController.computeColliderMovement( collider, desiredTranslation );

        //                 const computedMovement = this.characterController.computedMovement();
        //                 const velocity = new THREE.Vector3(computedMovement.x, computedMovement.y, computedMovement.z)
        //                     .divideScalar(this.world.timestep);
        //                 entity.physical.setLinvel(velocity);
        //             }
        //             entity.visual.position.copy(entity.physical.translation());
        //             entity.visual.quaternion.copy(entity.physical.rotation());
        //         }
        //     }
        // });

        if (this.debug) physicsDebug.update( this.world );
    }

    updatePhysics() {
        // console.log('Physics update');
    }


    setInputsMap( inputsMap ) {
        this.inputs = new Inputs(inputsMap);
    }

    addGameObject( gameObject ) {
        // console.log('Adding game object');

        let uuid;
        do {
            uuid = THREE.MathUtils.generateUUID()
        }
        while ( this.gameObjects.has( uuid ) )
        gameObject.uuid = uuid;

        this.gameObjects.set( gameObject.uuid, gameObject );

        gameObject.links.forEach( (link) => {
            this.scene.add( link.visual );
        })

        return gameObject;
    }
})

customElements.define('game-viewport', class extends HTMLElement {
    constructor() {
        super();
        this.style.display = 'block';
        this.style.width = '100%';
        this.style.height = '100%';
        // this.style.position = 'relative';
    }
    async connectedCallback() {
        this.canvas = document.createElement('canvas');
        this.canvas.style.display = 'block';
        this.canvas.style.width = '100%';
        this.canvas.style.height = '100%';
        this.appendChild(this.canvas);

        this.renderer = new THREE.WebGPURenderer({
            canvas: this.canvas,
            antialias: true,
            forceWebGL: this.hasAttribute('webgl'),
        });

        this.camera = new THREE.PerspectiveCamera( 40, this.canvas.width / this.canvas.height, 0.1, 1000 );
        this.camera.position.set( 0, 0, 5 );
        this.camera.lookAt( 0, 0, 0 );

        if ( this.parentElement.localName === 'game-app' ) {
            this.scene = this.parentElement.scene;
            window.addEventListener('resize', () => this.updateRendererSize());
            this.renderer.setAnimationLoop( (time) => this.animate(time) );
        }
        else {
            throw console.error('<game-viewport> must be a child of <game-app>!');
        }

        console.log('Viewport initialized!');
    }

    static get observedAttributes() {
        return ['stats-gl'];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'stats-gl') {
            if (this.hasAttribute('stats-gl') && !this.stats) {
                const Stats = await import('stats-gl');
                this.stats = new Stats.default({
                    trackGPU: true, // track GPU usage (vivaldi:flags/#enable-webgl-developer-extensions)
                });
                document.body.appendChild(this.stats.dom);
                this.stats.init( this.renderer );
            }
            else if (!this.hasAttribute('stats-gl') && this.stats) {
                this.stats.dom.remove();
                this.stats = null;
            }
        }
    }

    updateRendererSize() {
        this.camera.aspect = this.canvas.clientWidth / this.canvas.clientHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( this.canvas.clientWidth, this.canvas.clientHeight, false );
    }

    animate(timeElapsed) {
        this.renderUpdate ( timeElapsed );
        this.renderer.renderAsync( this.scene, this.camera );
        if (this.stats) this.renderer.resolveTimestampsAsync( THREE.TimestampQuery.RENDER );

        if (this.orbitControls) this.orbitControls.update();
        if (this.stats) this.stats.update();
    }

    renderUpdate( time ) {
        // console.log(time);
    }
})